import React from "react"

import {
	Box,
	Grid
} from "@mui/material"

import {
	t
} from "@lingui/macro"

import {
	ErrorResponse, Loading,
	RestResponse,
} from "@sinossi/mates-react-library"

import {
	Action, DashboardResponse, PaginatedResponse, SearchFilter, SessionResponse
} from "models"

import { PageSectionTitle } from "components/commons"
import { MatesComponent, MatesComponentState } from "components/mates-component"
import MicrojobDetailModal from "components/microjob/microjob-detail-modal/microjob-detail-modal"
import { MicrojobJobsTable } from "components/microjob/microjob-jobs-table/microjob-jobs-table"
import { MicrojobServices } from "services/microjob.services"
import { UseRouterParams } from "services/router"
import {
	DashboardCard,
	DashboardCardsData,
	DashboardCardWithList
} from "."

interface DashboardMicrojobberProps extends UseRouterParams {
	dashboardData: DashboardResponse
	actions: PaginatedResponse<Action> | null
	notifications: PaginatedResponse<Action> | null

	onException: (response: RestResponse<any, ErrorResponse>) => void

	refreshActions: () => void

	sessionData: SessionResponse
}
interface DashboardMicrojobberState extends MatesComponentState {
	loading: boolean
	microjobs: PaginatedResponse<any> | null,
	availableMicrojobs: PaginatedResponse<any> | null,
	microjobDetailModalOpen: boolean,
	selectedMicrojob: any
	request: any
}
export class DashboardMicrojobber extends React.Component<DashboardMicrojobberProps, DashboardMicrojobberState> {

	private readonly matesComponent: MatesComponent<DashboardMicrojobberProps, DashboardMicrojobberState> = new MatesComponent(this)

	private selectedMicrojob: any;

	constructor(props: DashboardMicrojobberProps) {
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			loading: false,
			request: SearchFilter.empty(),
			microjobs: null,
			availableMicrojobs: null,
			selectedMicrojob: null,
			microjobDetailModalOpen: false
		}
	}

	public componentDidMount() {
		this.filterMicrojobs()
	}

	private filterMicrojobs = (): void => {

		MicrojobServices.getUserMicrojobs(
			this.state.request,
			this.getMicrojobsJobsCallback,
			this.matesComponent.onError
		)
	}

	private getMicrojobsJobsCallback = (response: RestResponse<PaginatedResponse<any>, ErrorResponse>): void => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.setState(() => ({
			microjobs: response.data,
		}))

		MicrojobServices.getAvailableMicrojobs(
			this.state.request,
			this.getAvailableMicrojobsCallback,
			this.matesComponent.onError
		)
	}


	private getAvailableMicrojobsCallback = (response: RestResponse<PaginatedResponse<any>, ErrorResponse>): void => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.setState(() => ({
			loading: false,
			availableMicrojobs: response.data,
		}))
	}

	private openMicrojobDetail = (microjob: any) => {

		this.setState(() => ({
			selectedMicrojob: microjob,
			microjobDetailModalOpen: true
		}))

	}


	private closeMicrojobDetail = () => {

		this.setState(() => ({
			microjobDetailModalOpen: false,
			selectedMicrojob: null
		}))

	}


	private takeMicrojobCallback = () => {

		this.setState(() => ({
			loading: false,
			selectedMicrojob: null
		}))

		window.location.reload();
	}

	private takeMicrojob = (data: any) => {

		this.setState(() => ({
			microjobDetailModalOpen: false,
			loading: true
		}))

		MicrojobServices.takeMicrojob(
			this.state.selectedMicrojob.id,
			this.takeMicrojobCallback,
			this.matesComponent.onError
		)
	}

	private concludeMicrojob = (answer: string) => {

		this.setState(() => ({
			microjobDetailModalOpen: false,
			loading: true
		}))

		const request = {
			answer
		}

		MicrojobServices.concludeMicrojob(
			this.state.selectedMicrojob.id,
			request,
			this.concludeMicrojobCallback,
			this.matesComponent.onError
		)
	}

	private concludeMicrojobCallback = () => {

		this.setState(() => ({
			loading: false,
			selectedMicrojob: null
		}))

		window.location.reload();

	}

	private handleTableCallback = (data: any) => {
		/*this.setState(
			() => ({
				loading: true,
				request: {
					...this.state.request,
					...data,
				},
			}),
			this.filterMicrojobs
		)*/
	}


	render() {
		return (
			<>
				<Loading show={this.state.loading} />
				{
					!this.state.loading && <>
						{this.state.microjobDetailModalOpen && <MicrojobDetailModal
							microjob={this.state.selectedMicrojob}
							onClose={this.closeMicrojobDetail}
							onMicrojobConclude={this.concludeMicrojob}
							onMicrojobTake={this.takeMicrojob}
							isAdmin={false}
						/>}
						<Grid container alignItems="stretch" spacing={2}>
							<Grid item xs={12} lg={4} sx={{ height: '100%' }}>
								{this.props.actions &&
									<DashboardCardWithList
										cardType={DashboardCardsData.ACTIONS}
										data={this.props.actions}
										sessionData={this.props.sessionData}
										refreshPage={this.props.refreshActions}
										brand
									/>
								}
							</Grid>
							<Grid container item xs={12} md={4} sx={{ height: '100%' }} spacing={2} direction="column">
								<Grid item xs={12} md={6}>
									<DashboardCard
										cardType={DashboardCardsData.CONCLUDED_JOBS}
										value={3}
										percentage={0}
										notifications={0} />
								</Grid>
								<Grid item xs={12} md={6}>
									<DashboardCard
										cardType={DashboardCardsData.JOB_COMPLETITION_RATE}
										value={70}
										isPercentage
										percentage={0}
										notifications={0} />
								</Grid>
							</Grid>
							<Grid container item xs={12} md={4} sx={{ height: '100%' }} spacing={2} direction="column">
								<Grid item xs={12} md={6} >
									<DashboardCard
										cardType={DashboardCardsData.RECEIVED_JOBS}
										value={2}
										percentage={0}
										notifications={0} />
								</Grid>
								<Grid item xs={12} md={6}>
									<DashboardCard
										cardType={DashboardCardsData.JOB_VALUE}
										value={"350  €"}
										percentage={0}
										notifications={0} />

								</Grid>
							</Grid>
							<Grid item xs={12} lg={6} sx={{ mt: 3 }}>
								<Box >
									<PageSectionTitle title={t({ id: "microjob-jobs-available-title-table", message: "Microjob disponibili" })} />
									{
										this.state.microjobs &&
										<MicrojobJobsTable
											openModal={this.openMicrojobDetail}
											data={this.state.availableMicrojobs}
											handleCallback={this.handleTableCallback} />
									}
								</Box>
							</Grid>
							<Grid item xs={12} lg={6} sx={{ mt: 3 }}>
								<Box >
									<PageSectionTitle title={t({ id: "microjob-jobs-my-title-table", message: "I miei Microjob" })} />
									{
										this.state.availableMicrojobs &&
										<MicrojobJobsTable
											openModal={this.openMicrojobDetail}
											data={this.state.microjobs}
											handleCallback={this.handleTableCallback} />
									}
								</Box>
							</Grid>
						</Grid >
					</>
				}
			</>
		)
	}
}
